export default __webpack_public_path__ + "static/media/resizing-control.db90b84f.svg";